module.exports = __webpack_public_path__ + "img/GregKocik_140x140_rund.b22a5d0c.jpg";